import {
  PRINTOS_SELECTOR,
  isDocumentLoading,
} from './mount-helper';
import services from '@/services';

/**
 * Mounts the top bar when the mounting point element is available.
 * This allows for adding the main script in the head or body as well
 * as the mounting point element being dynamically added.
 *
 * @returns Promise
 */
export function mountWhenAvailable() {
  // Return a promise for testing
  return new Promise(resolve => {
    if (isDocumentLoading()) {
      // Wait for DOM content loaded so that we can put the script in document.head
      // which may be called before the body is loaded.
      document.addEventListener('DOMContentLoaded', () => {
        resolve(observeForMountingPoint());
      });
    } else {
      // body already loaded
      resolve(observeForMountingPoint());
    }
  });
}

function observeForMountingPoint() {
  return new Promise(resolve => {
    let mountingPoint = document.body.querySelector(PRINTOS_SELECTOR);
    if (mountingPoint) {
      // mountTopBar(mountingPoint);
      return resolve(mountingPoint);
    }

    let observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        switch(mutation.type) {
          case 'attribute': {
            if (mutation.attributeName === 'class'
              && mutation.target.getAttribute('class').indexOf('printos') >= 0) {
              mountingPoint = mutation.target;
              observer.disconnect(mountingPoint);
              window.document.body.setAttribute('foundattr', 'true');
              // mountTopBar(mountingPoint);
              resolve(mountingPoint);
            }
            break;
          }
          case 'childList': {
            // Need to use a query selector here since the mutation may include
            // an added tree and does not notify for every element added in that tree.
            mountingPoint = mutation.target.querySelector(PRINTOS_SELECTOR);
            if (mountingPoint) {
              observer.disconnect();
              window.document.body.setAttribute('foundchild', 'true');
              // mountTopBar(mountingPoint);
              resolve(mountingPoint);
            }
            break;
          }
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: false,
    });
  });
}

function getAttributesAsObject(el) {
  let result = {};
  let attrs = el.attributes;
  for(let i = 0; i < attrs.length; i++) {
    result[attrs[i].name] = attrs[i].value;
  }
  return result;
}
